import { setupODA } from './ODA.bootstrap';

setupODA();

